<h2 mat-dialog-title>{{ 'ADD_COMPANY' | translate }}</h2>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <mat-radio-group class="block -mx-2 mb-2" formControlName="IsCompany">
      <mat-radio-button [value]="true" class="margin-right">
        {{ 'COMPANY' | translate }}
      </mat-radio-button>
      <mat-radio-button [value]="false" class="margin-right">
        {{ 'PRIVATE' | translate }}
      </mat-radio-button>
    </mat-radio-group>

    <mat-form-field class="w-full">
      <mat-label>{{ 'COUNTRY' | translate }}</mat-label>

      <sc-filtered-select
        formControlName="FK_CountryID"
        name="FK_CountryID"
        [options]="countries()"
        [required]="true"
        displayField="Name"
        valueField="PK_CountryID">
      </sc-filtered-select>
    </mat-form-field>

    @if (form.controls.IsCompany.value) {
      <mat-form-field class="w-full">
        <mat-label>{{ 'ORGANIZATION_NUMBER' | translate }}</mat-label>
        <input matInput evTrimOnPaste [removeWhitespaces]="true" formControlName="CompanyNumber" />
        <mat-error scError controlName="CompanyNumber"></mat-error>
      </mat-form-field>
    }

    @if (publicInformations()) {
      <h3>{{ 'CONTACT_INFORMATION' | translate }}</h3>

      @if (departmentRequired()) {
        <div class="alert alert-soft alert-warning mb-4">
          {{ 'COMPANY_EXISTS_DEPARTMENT_NEEDED' | translate }}
        </div>
      }

      <mat-form-field class="w-full">
        <mat-label>{{ (form.controls.IsCompany.value ? 'COMPANY_NAME' : 'CONTACT_PERSON') | translate }}</mat-label>
        <input matInput formControlName="Name" />
        <mat-error scError controlName="Name"></mat-error>
      </mat-form-field>

      @if (form.controls.IsCompany.value) {
        <mat-form-field class="w-full">
          <mat-label>{{ 'DEPARTMENT' | translate }}</mat-label>
          <input matInput formControlName="Department" />
          <mat-error scError controlName="Department"></mat-error>
        </mat-form-field>
      }

      <div class="w-full flex items-center justify-between" *canSee="UserType.Admin">
        <sc-user-search
          class="w-full"
          [customerID]="form.controls.OwnedByCustomerID.value"
          fieldLabel="COMPANY_ADMINISTRATOR"
          (clear)="selectCustomer()"
          [enter]="false"
          (itemSelected)="selectCustomer($event)"></sc-user-search>
        <button mat-icon-button type="button" (click)="addCustomer()">
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <mat-form-field class="w-full">
        <mat-label>{{ 'CONTACT_EMAIL' | translate }}</mat-label>
        <input matInput type="email" formControlName="Email" />
        <mat-error scError controlName="Email"></mat-error>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>{{ 'ADDRESS' | translate }}</mat-label>
        <input matInput formControlName="Address" />
        <mat-error scError controlName="Address"></mat-error>
      </mat-form-field>

      <div class="flex gap-2">
        <mat-form-field class="w-full">
          <mat-label>{{ 'ZIP_CODE' | translate }}</mat-label>
          <input matInput type="text" formControlName="PostCode" />
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>{{ 'CITY_TOWN' | translate }}</mat-label>
          <input matInput formControlName="City" />
        </mat-form-field>
      </div>

      <mat-form-field class="w-full">
        <mat-label>{{ 'PHONE' | translate }}</mat-label>
        @if (selectedCountry(); as country) {
          <span matPrefix class="txt-gray">+{{ country.DialingCode }}</span>
        }
        <input matInput type="text" formControlName="Phone" />
      </mat-form-field>

      <h3>{{ 'INVOICE_INFORMATION' | translate }}</h3>

      @if (form.controls.IsCompany.value) {
        <mat-checkbox class="-mx-2 !block" formControlName="HasVATBeenApproved">
          {{ 'VAT_APPLICABLE' | translate }}
        </mat-checkbox>
      }

      @if (selectedCountry().CountryCode !== 'NO') {
        <mat-form-field class="w-full">
          <mat-label>{{ 'VAT_NUMBER' | translate }}</mat-label>
          <input matInput type="text" formControlName="VATNumber" />
          <mat-error scError controlName="VATNumber"></mat-error>
        </mat-form-field>
      }

      <mat-checkbox class="-mx-2 !block" formControlName="UseContactInfo">
        {{ 'CONTACT_INFO_FOR_INVOICING' | translate }}
      </mat-checkbox>

      @if (form.controls.UseContactInfo.value === false) {
        <mat-form-field class="w-full">
          <mat-label>{{
            (form.controls.IsCompany.value ? 'INVOICE_COMPANY_NAME' : 'INVOICE_NAME') | translate
          }}</mat-label>
          <input matInput formControlName="InvoiceName" />
          <mat-error scError controlName="InvoiceName"></mat-error>
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>{{ 'ADDRESS_LINE_1' | translate }}</mat-label>
          <input matInput formControlName="InvoiceAddress" />
          <mat-error scError controlName="InvoiceAddress"></mat-error>
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>{{ 'ADDRESS_LINE_2' | translate }}</mat-label>
          <input matInput formControlName="InvoiceAddress2" />
          <mat-error scError controlName="InvoiceAddress2"></mat-error>
        </mat-form-field>

        <div class="flex gap-2">
          <mat-form-field class="w-full">
            <mat-label>{{ 'ZIP_CODE' | translate }}</mat-label>
            <input matInput type="text" formControlName="InvoicePostCode" />
          </mat-form-field>

          <mat-form-field class="w-full">
            <mat-label>{{ 'CITY_TOWN' | translate }}</mat-label>
            <input matInput formControlName="InvoiceCity" />
          </mat-form-field>
        </div>

        <mat-form-field class="w-full">
          <mat-label>{{ 'COUNTRY' | translate }}</mat-label>

          <sc-filtered-select
            formControlName="FK_InvoiceCountryID"
            name="FK_InvoiceCountryID"
            [options]="countries()"
            displayField="Name"
            valueField="PK_CountryID">
          </sc-filtered-select>
        </mat-form-field>
      }

      <mat-form-field class="w-full">
        <mat-chip-grid
          #sequenceListInvoiceEmails
          class="sequence-list"
          formControlName="InvoiceEmail"
          cdkDropList
          cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="sequenceDrop($event, form.controls.InvoiceEmail)">
          @for (value of form.controls.InvoiceEmail.value; track $index) {
            <mat-chip-row
              class="sequence-list-chip"
              [removable]="true"
              (removed)="sequenceRemove(form.controls.InvoiceEmail, value)">
              {{ value }}
              <mat-icon matChipRemove>close</mat-icon>
            </mat-chip-row>
          }
          <input
            class="sequence-list-input"
            placeholder="{{ 'INVOICE_RECIPIENTS' | translate }}"
            [matChipInputFor]="sequenceListInvoiceEmails"
            [matChipInputSeparatorKeyCodes]="[ENTER, COMMA]"
            (matChipInputTokenEnd)="sequenceAdd($event, form.controls.InvoiceEmail)"
            (keyup)="sequenceInputChange($event, form.controls.InvoiceEmail)" />
        </mat-chip-grid>
        <button
          mat-icon-button
          matSuffix
          class="txt-gray input-helper"
          type="button"
          matTooltip="{{ 'MULTIPLE_EMAILS_ALLOWED' | translate }}">
          <mat-icon>help_outline</mat-icon>
        </button>
        <mat-error scError controlName="InvoiceEmail"></mat-error>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-chip-grid
          #sequenceListSettlementEmails
          class="sequence-list"
          formControlName="SettlementEmails"
          cdkDropList
          cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="sequenceDrop($event, form.controls.SettlementEmails)">
          @for (value of form.controls.SettlementEmails.value; track $index) {
            <mat-chip-row
              class="sequence-list-chip"
              [removable]="true"
              (removed)="sequenceRemove(form.controls.SettlementEmails, value)">
              {{ value }}
              <mat-icon matChipRemove>close</mat-icon>
            </mat-chip-row>
          }
          <input
            class="sequence-list-input"
            placeholder="{{ 'SETTLEMENT_RECIPIENTS' | translate }}"
            [matChipInputFor]="sequenceListSettlementEmails"
            [matChipInputSeparatorKeyCodes]="[ENTER, COMMA]"
            (matChipInputTokenEnd)="sequenceAdd($event, form.controls.SettlementEmails)"
            (keyup)="sequenceInputChange($event, form.controls.SettlementEmails)" />
        </mat-chip-grid>
        <button
          mat-icon-button
          matSuffix
          class="txt-gray input-helper"
          type="button"
          matTooltip="{{ 'MULTIPLE_EMAILS_ALLOWED' | translate }}">
          <mat-icon>help_outline</mat-icon>
        </button>
        <mat-error scError controlName="SettlementEmails"></mat-error>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>{{ 'INVOICE_LANGUAGE' | translate }}</mat-label>
        <mat-select formControlName="InvoicingLanguage">
          @for (language of languages(); track language.Key) {
            <mat-option [value]="language.Key">
              {{ language.LanguageName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>
          {{ 'INVOICE_REFERENCE' | translate }}

          @if (selectedCountry().CountryCode === 'NO') {
            / KID
          }
        </mat-label>
        <input matInput type="text" formControlName="InvoiceReference" />
        <mat-error scError controlName="InvoiceReference"></mat-error>
        <button
          mat-icon-button
          matSuffix
          class="txt-gray input-helper"
          type="button"
          matTooltip="{{ 'MARKED_ON_THE_INVOICE' | translate }}">
          <mat-icon>help_outline</mat-icon>
        </button>
      </mat-form-field>

      @if (selectedCountry().CountryCode !== 'NO') {
        <mat-form-field class="w-full">
          <mat-label>{{ 'E_INVOICING_ADDRESS' | translate }}</mat-label>
          <input matInput type="text" formControlName="EInvoicingAddress" />
          <button
            mat-icon-button
            matSuffix
            class="txt-gray input-helper"
            type="button"
            matTooltip="{{ 'COMPANY_INFO_TEXT_34' | translate }}">
            <mat-icon>help_outline</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>{{ 'E_INVOICE_INTERMEDIATOR' | translate }}</mat-label>
          <mat-select formControlName="EInvoicingProvider">
            @for (intermediator of Intermediators; track intermediator.key) {
              <mat-option [value]="intermediator.key">
                {{ intermediator.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <h3>{{ 'PAYOUTS' | translate }}</h3>

      @if (selectedCountry(); as country) {
        @if (country.BankAccountTypes.length > 1) {
          <mat-form-field class="w-full">
            <mat-label>{{ 'ACCOUNT_TYPE' | translate }}</mat-label>
            <mat-select formControlName="BankAccountNumberType">
              @for (accountType of country.BankAccountTypes; track accountType.AccountType) {
                <mat-option [value]="accountType.AccountType">
                  {{ accountType.Name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        @if (country.BankAccountTypes.length) {
          <mat-form-field class="w-full">
            <mat-label>{{ 'ACCOUNT_NUMBER' | translate }}</mat-label>
            <input matInput formControlName="BankAccountNumber" />
          </mat-form-field>
        }

        @if (country.CountryCode === 'NO') {
          <mat-slide-toggle [(ngModel)]="showIBAN" [ngModelOptions]="{ standalone: true }" class="mb-3">
            {{ 'COMPANY_INFO_TEXT_35' | translate }}
          </mat-slide-toggle>
        }

        @if (country.CountryCode !== 'NO' || showIBAN) {
          <mat-form-field class="w-full">
            <mat-label>{{ 'BIC_SWIFT' | translate }}</mat-label>
            <input matInput formControlName="BIC_SWIFT" />
          </mat-form-field>

          <mat-form-field class="w-full">
            <mat-label>{{ 'IBAN' | translate }}</mat-label>
            <input matInput formControlName="IBAN" />
          </mat-form-field>
        }

        <mat-form-field class="w-full">
          <mat-label>
            {{ 'PAYOUT_REFERENCE' | translate }}

            @if (country.CountryCode === 'NO') {
              / KID
            }
          </mat-label>
          <input matInput type="text" formControlName="InvoiceReferencePayouts" />
          <mat-error scError controlName="InvoiceReferencePayouts"></mat-error>
          <button
            mat-icon-button
            matSuffix
            class="txt-gray input-helper"
            type="button"
            matTooltip="{{ 'COMPANY_INFO_TEXT_36' | translate }}">
            <mat-icon>help_outline</mat-icon>
          </button>
        </mat-form-field>
      }
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    @if (publicInformations()) {
      <button mat-raised-button type="submit" color="primary" [disabled]="form.invalid">{{ 'ADD' | translate }}</button>
    } @else {
      <button
        mat-raised-button
        type="button"
        color="primary"
        [disabled]="form.controls.FK_CountryID.invalid || form.controls.CompanyNumber.invalid"
        (click)="checkCompanyNumber()">
        {{ 'CONTINUE' | translate }}
      </button>
    }

    <button mat-raised-button mat-dialog-close>{{ 'CANCEL' | translate }}</button>
  </mat-dialog-actions>
</form>
